/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Select_Profile_PlaceholderInputs */

const en_editor_select_profile_placeholder = /** @type {(inputs: Editor_Select_Profile_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a profile`)
};

const fr_editor_select_profile_placeholder = /** @type {(inputs: Editor_Select_Profile_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionnez un profil`)
};

const de_editor_select_profile_placeholder = /** @type {(inputs: Editor_Select_Profile_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie ein Profil aus`)
};

const it_editor_select_profile_placeholder = /** @type {(inputs: Editor_Select_Profile_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un profilo`)
};

const ru_editor_select_profile_placeholder = /** @type {(inputs: Editor_Select_Profile_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите профиль`)
};

const es_editor_select_profile_placeholder = /** @type {(inputs: Editor_Select_Profile_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione un perfil`)
};

const zh_cn2_editor_select_profile_placeholder = /** @type {(inputs: Editor_Select_Profile_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择个人资料`)
};

const ja_editor_select_profile_placeholder = /** @type {(inputs: Editor_Select_Profile_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロフィールを選択`)
};

const hi_editor_select_profile_placeholder = /** @type {(inputs: Editor_Select_Profile_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक प्रोफ़ाइल चुनें`)
};

const pt_pt2_editor_select_profile_placeholder = /** @type {(inputs: Editor_Select_Profile_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione um perfil`)
};

/**
* | output |
* | --- |
* | "Select a profile" |
*
* @param {Editor_Select_Profile_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_select_profile_placeholder = /** @type {((inputs?: Editor_Select_Profile_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Select_Profile_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_select_profile_placeholder(inputs)
	if (locale === "de") return de_editor_select_profile_placeholder(inputs)
	if (locale === "it") return it_editor_select_profile_placeholder(inputs)
	if (locale === "ru") return ru_editor_select_profile_placeholder(inputs)
	if (locale === "es") return es_editor_select_profile_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_select_profile_placeholder(inputs)
	if (locale === "ja") return ja_editor_select_profile_placeholder(inputs)
	if (locale === "hi") return hi_editor_select_profile_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_select_profile_placeholder(inputs)
	return en_editor_select_profile_placeholder(inputs)
});